import styled from 'styled-components';
import { Heading5, Heading6 } from 'components/theme/Typography/Typography';

export const PickerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-bottom: 24px;
`;

export const UnitBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 0.5px solid var(--way-colors-borderColor);
  border-radius: 4px;
`;

export const UnitHeading = styled(Heading5)`
  margin-bottom: 0;
`;

export const ResourceGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ResourceName = styled(Heading6)`
  margin-bottom: 0;
`;

export const SelectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
`;
